import { render } from "./CompatibilityReportsDashboard.vue?vue&type=template&id=55a8a7cd&scoped=true"
import script from "./CompatibilityReportsDashboard.vue?vue&type=script&lang=js"
export * from "./CompatibilityReportsDashboard.vue?vue&type=script&lang=js"

import "./CompatibilityReportsDashboard.vue?vue&type=style&index=0&id=55a8a7cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a8a7cd"]])

export default __exports__